/**
 * @generated SignedSource<<c09c160e348987608133cd5068d9c77a>>
 * @relayHash 0fb7ba9477a850ce9061cd47921a39ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eb3ad1062789e90dfa25be000f11f17180ea080141de678232bb21cc5390c6ea

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SubspacesQuery } from './SubspacesQuery.graphql';

const node: PreloadableConcreteRequest<SubspacesQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "eb3ad1062789e90dfa25be000f11f17180ea080141de678232bb21cc5390c6ea",
    "metadata": {},
    "name": "SubspacesQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
